var _circle, _path, _path2, _g, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUpcoming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#F9FCEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3549 24.2861V42.181C45.3549 43.6593 44.136 44.8576 42.6324 44.8576H18.3631C16.8595 44.8576 15.6406 43.6592 15.6406 42.181V24.2861H45.3549Z",
    fill: "#E3EDC3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8537_130767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 24,
    width: 31,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3549 24.2861V42.181C45.3549 43.6593 44.136 44.8576 42.6324 44.8576H18.3631C16.8595 44.8576 15.6406 43.6592 15.6406 42.181V24.2861H45.3549Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8537_130767)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9106 24.2861L16.1641 44.6645H44.9106V24.2861Z",
    fill: "#F6FFD8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8474 30.1198C30.6233 29.9455 30.2991 29.9614 30.0931 30.1674L30.0456 30.2212C29.8713 30.4454 29.8872 30.7695 30.0931 30.9755L33.1173 34H26.4972L26.4306 34.0038C26.1464 34.0369 25.9258 34.2784 25.9258 34.5714C25.9258 34.887 26.1816 35.1429 26.4972 35.1429H33.1173L30.0931 38.1674L30.0456 38.2212C29.8713 38.4454 29.8872 38.7695 30.0931 38.9755C30.3163 39.1986 30.6781 39.1986 30.9013 38.9755L34.9013 34.9755C34.9181 34.9587 34.9338 34.9408 34.9484 34.9221L34.9488 34.9217C34.981 34.8803 35.0066 34.8356 35.0258 34.7888C35.0528 34.7234 35.0679 34.652 35.0686 34.5771C35.0686 34.5752 35.0686 34.5733 35.0686 34.5714C35.0686 34.5698 35.0686 34.5683 35.0686 34.5667C35.068 34.4914 35.0528 34.4196 35.0258 34.3539C34.9979 34.2861 34.9564 34.2225 34.9013 34.1674L30.9013 30.1674L30.8474 30.1198Z",
    fill: "#274642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1134 17.4941H43.0604C44.5783 17.4941 45.8087 18.7246 45.8087 20.2425V24.4043H15.8125V20.2425C15.8125 18.7246 17.043 17.4941 18.5608 17.4941H38.1134Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9983 14C37.7173 14 37.4856 14.2116 37.454 14.4841L37.4503 14.548V16.7876H23.6268L23.6271 14.56L23.6239 14.4917C23.5957 14.2138 23.3605 14 23.0787 14C22.7976 14 22.566 14.2116 22.5344 14.4841L22.5307 14.548V16.7876L18.1625 16.787C16.4792 16.8108 15.1106 18.1637 15.0708 19.8523L15.0703 42.6302C15.0946 44.2909 16.3963 45.6485 18.0424 45.7535L18.173 45.7591L42.9132 45.7592C44.5735 45.7159 45.9163 44.3989 46.0029 42.7523L46.0071 42.6216L46.0061 42.5027L46.0068 19.8793C45.9829 18.1958 44.6301 16.8272 42.9418 16.7875L38.5464 16.7876L38.5467 14.56L38.5435 14.4917C38.5153 14.2138 38.2801 14 37.9983 14ZM44.91 42.4991L44.91 24.5582H16.167V42.5027L16.1654 42.562L16.1658 42.628C16.1904 43.7338 17.0752 44.6259 18.1761 44.663L18.2874 44.6637L42.8482 44.6641L42.9144 44.6624L43.0282 44.6545C44.0827 44.5524 44.8977 43.6739 44.9116 42.6105L44.91 42.4991ZM18.2887 17.8836L18.2356 17.882L18.1777 17.882L18.1175 17.8839C17.0348 17.9321 16.1798 18.8171 16.1654 19.8961L16.167 20.0091L16.167 23.4621H44.9101V20.0054L44.9118 19.9523C44.9123 19.915 44.9117 19.8746 44.9099 19.8342C44.8636 18.7955 44.0451 17.9604 43.0161 17.8871L42.9045 17.8823L42.7846 17.8837L38.5464 17.8837V20.084L38.5427 20.1479C38.511 20.4205 38.2794 20.632 37.9983 20.632C37.7165 20.632 37.4813 20.4183 37.4531 20.1403L37.45 20.072L37.4503 17.8837H23.6268V20.0839L23.6231 20.1478C23.5914 20.4204 23.3598 20.6319 23.0787 20.6319C22.7969 20.6319 22.5617 20.4182 22.5335 20.1402L22.5304 20.0719L22.5307 17.8836H18.2887Z",
    fill: "#274642"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUpcoming);
export default __webpack_public_path__ + "static/media/ico_upcoming.95473798222d059e37460d5fc25019b8.svg";
export { ForwardRef as ReactComponent };